import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
    name: 'mandateLabel',
    standalone: false
})
export class MandateLabelPipe implements PipeTransform {

    static format(mandate: Record<string, any>, codeName = 'ReferenceMandat', labelName = 'LibelleCompteBancaire'): string {

        const values = [mandate?.[codeName]];
        const label = mandate?.[labelName]
        if(label){
            values.push(` ( ${label} )`);
        }

        return values.filter(e => !!e).join(' - ');
    }

    transform(mandate: Record<string, any>, codeName = 'ReferenceMandat', labelName = 'LibelleCompteBancaire'): string {
        return MandateLabelPipe.format(mandate, codeName, labelName);
    }

}
